import {connect} from 'react-redux';
import {Signatures} from 'report-components'
import {updateReportSignature,addReportSignature,deleteReportSignature, addAvailableSignature, autoSaveRemove, updateReportSignaturesOrder, autoSaveOrder, autoSaveUpdate} from 'report-components/lib/reducers';
import {getNewId,getItems,makeMapStateToProps} from 'report-components/lib/selectors'
import {getResource} from '../lib'
import {postFetcher} from 'startlibs'

const autoSaveType = {type: 'reportSignature'}

const uploadFetcher = (formData) => postFetcher('/api/upload-signature', formData)

export const ReportSignatures = connect(
  makeMapStateToProps({getNewId, getItems, getItems2: getItems})(
    ({getNewId, getItems, getItems2}) => ({report})=> ({
      reportSignatures: getItems(report.reportSignatures),
      newId: getNewId(report.reportSignatures),
      availableSignatures: report.availableSignatures,
      availableSignaturesArray: getItems2(report.availableSignatures),
      newSignatureAction: addAvailableSignature,
      hidePermissionsSettings: true,
      getResource,
      uploadFetcher
    })),
  dispatch => ({
    update: (signature) => {
      const r = dispatch(updateReportSignature(signature))
      dispatch(autoSaveUpdate(signature, autoSaveType))
      return r
    },
    addNew: (signature, index) => {
      const r = dispatch(addReportSignature(signature, {index}))
      dispatch(autoSaveUpdate(signature, autoSaveType))
      return r
    },
    confirmRemoveItem: (id) => dispatch(autoSaveRemove(id, autoSaveType)),
    remove: (id) => dispatch(deleteReportSignature(id)),
    updateOrder: (newOrder) => {
      dispatch(updateReportSignaturesOrder(newOrder))
      dispatch(autoSaveOrder(newOrder, autoSaveType))
    }
  })
)(Signatures)


// WEBPACK FOOTER //
// ./src/javascripts/report/ReportSignatures.jsx